import {BaseUtils} from "./base.utils";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {IDocument} from "../../interfaces/document.definition";
import {JP} from "../../helpers/jp";
import {IRestriction} from "./restriction.utils";
import {ONMAP_TAGS} from "../../enums/e-onmap-tags";

export interface IOnmapDialog extends IDocument{
  restrictions:IRestriction[];
  participants:IParticipant[];
  tags:ITag[];
  phrases:IPhrase[];
}

export interface IParticipant {
  category:string;
  id?:number;
}

export interface ITag {
  tag:string;
  count:number;
  category?:string;
  id?:number;
}

export interface IPhrase {
  speaker:number;
  delay:number;
}

export class OnmapDialogUtils extends BaseUtils{

  addParticipantTo(dialog:IOnmapDialog){
    let p:IParticipant = this.createParticipant();
    this.pushUsingPointer(dialog,'/participants', p);
  }

  addTagTo(dialog:IOnmapDialog){
    let t:ITag = this.createTag();
    this.pushUsingPointer(dialog, '/tags', t);
  }

  addPhraseTo(dialog:IOnmapDialog){
    let ph:IPhrase = this.createPhrase();
    this.pushUsingPointer(dialog, '/phrases', ph);
  }

  private createParticipant():IParticipant{
    let p:IParticipant = <IParticipant>
      {
        category:GO_CATEGORIES.SHMU
      }
    return p;
  }

  private createTag():ITag{
    let t:ITag = <ITag>
      {
        tag:ONMAP_TAGS.QUEST_COMPLETED,
        count:1
      };
    return t;
  }

  private createPhrase():IPhrase{
    let ph:IPhrase = <IPhrase>
      {
        speaker:0,
        delay:0
      };
    return ph;
  }

  private pushUsingPointer(document: any,
                           pointer: string,
                           newItem: any) {
    JP.set(document, `${pointer}/-`, newItem);
    this.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/onmap-dialog.utils.ts